import { useMemo } from 'react';
import useAxios from 'axios-hooks';
import { IOnlineSalesConfig } from '../types/strapi/online-sales-config';

const DEFAULT_CONFIG: IOnlineSalesConfig = {
  id: 0,
  shippingCost: 1.5,
  freeShippingThreshold: 40,
  stripeShippingCost: 5.0,
  stripeDeliveryMinDays: 2,
  stripeDeliveryMaxDays: 5,
};

export const useOnlineSalesConfig = () => {
  const [{ data, loading, error }] = useAxios<IOnlineSalesConfig>({
    url: '/online-sales-config',
    method: 'GET',
  });

  const config = useMemo(() => {
    return data || DEFAULT_CONFIG;
  }, [data]);

  return { config, loading, error };
};
